export default __webpack_public_path__ + "static/media/0xf6422b997c7f54d1c6a6e103bcb1499eea0a7046.74008125.svg";